// extracted by mini-css-extract-plugin
export default {"modalWrapper":"CreateEditFolderModal_modalWrapper__TVzlr"};